export const baseUsersUrl = '/users/profile'

export const baseSupplierUrl = '/suppliers'
